import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { AuthenticationService, CredentialService, OrderService, PrinterService, ShipmentService } from '../../../services';

import { industrialTemplateIds } from 'ngrx/industrial-template-ids';
import { FedExServiceTypeMapping, shipmentDisplayTypes } from 'ngrx/shipment-options';
import { BsModalService } from 'ngx-bootstrap';
import { stateCodes } from '../../../../ngrx/state-codes';
import { environment } from '../../../../environments/environment';


const labelShapes = {
    1 : 'Rectangle',
    2 : 'Round',
    3 : 'Oval',
    4 : 'Square',
    5 : 'Custom',
}
@Component({
  selector: 'rfid-packing-slip-modal',
  templateUrl: 'rfid-packing-slip-modal.component.html',
  styleUrls:   ['rfid-packing-slip-modal.component.scss']
})
export class RFIDPackingSlipModal implements OnInit, OnDestroy {
  @Input('jobs')            jobs;
  @Input('order')           order;
  @Input('shipment')        shipment;
  @Input('page')            page;
  initSubscriptions      : Subscription[];
  process                : Observable<string>;
  shipmentDetailsView    : Observable<any>;
  labelsPerLane          : number;
  brandLogo              : string;
  logoWidth              : string;
  layout                 : string;
  stateCodes             : any = stateCodes;
  shipmentDisplayTypes   : any = shipmentDisplayTypes;
  FedExServiceTypeMapping: any = FedExServiceTypeMapping;
  packingSlipPrinting    : boolean;
  labelShapes            : any = labelShapes;
  packingSlipMsg         : string;
  splitTotalQty          : Object = {};
  mtOrderNumber          : string;
  customerPO             : string;
  idcSalesOrderNumber    : string;                         //ID&C
  idcPO                  : string;                         //ID&C
  info                   : Object = {};                    //info for either mastertag or id&c 
  thumbnailURLs          : string[];
  industrialTemplateIds  : any = industrialTemplateIds;
  phoneNumber            : string;

  //Shuffle Artworks styles
  private shuffleArtworkTemplate: { [k: number]: Array<{ left: number, top: number }> } = {
    1: [{ left: 0,  top: 0 }],
    2: [{ left: -1, top: 0 }, { left: 23, top: 52 }],
    3: [{ left: -1, top: 0 }, { left: 17, top: 30 }, { left: 34, top: 70 }],
    4: [{ left: -1, top: 0 }, { left: 37, top: 25 }, { left: -1, top: 56 }, { left: 37, top: 78 }],
    5: [{ left: 2, top: 0 }, { left: 44, top: 10 }, { left: 2, top: 40 }, { left: 44, top: 65 }, { left: 2, top: 88 }],
    6: [{ left: 2, top: 0 }, { left: 44, top: 10 }, { left: 2, top: 42 }, { left: 44, top: 54 }, { left: 2, top: 76 }, { left: 44, top: 90 }],
    7: [{ left: 2, top: 0 }, { left: 44, top: 10 }, { left: 2, top: 25 }, { left: 44, top: 44 }, { left: 2, top: 64 }, { left: 44, top: 78 }, { left: 2, top: 92 }],
  };
  private heightByCount: { [k: number]: string } = { 1: '100%', 2: '60%', 3: '50%', 4: '47%', 5: '40%', 6: '40%', 7: '40%' };
  private widthByCount : { [k: number]: string } = { 1: '100%', 2: '50%', 3: '50%', 4: '50%', 5: '50%', 6: '50%', 7: '50%' };
  constructor(
    private orderService     : OrderService,
    private authService      : AuthenticationService,
    private shipmentService  : ShipmentService,
    private printerService   : PrinterService,
    private modalService     : BsModalService,
    private credentialService: CredentialService,
  ) {
    this.process             = this.authService.getCurrentProcess();
    this.shipmentDetailsView = this.shipmentService.getShipmentDetailsView();
  }
  
  ngOnInit(): void {
    console.log('this.jobs', this.jobs)
    console.log('this.order', this.order)
    console.log('this.shipment', this.shipment)

    let customerInfo;
    switch (this.order.customer.outsource) {
      case 'idcband':
        customerInfo = {
          phoneNumber: '(941) 739-6935',
          brandLogo: 'https://s3.us-east-1.amazonaws.com/impreso.sheet.asset/ID%26C+Logo.png'
        };
        break;
      case 'rfid':
        customerInfo = {
          phoneNumber: '(888) 249-3068',
          brandLogo: 'https://s3.us-east-1.amazonaws.com/impreso.sheet.asset/RFID_Hotel_RLogo_black.png'
        };
        break;
      case 'imprintplus':
        customerInfo = {
          phoneNumber: '1-800-563-2464',
          brandLogo: 'https://s3.us-east-1.amazonaws.com/impreso.sheet.asset/Imprintplus_logo_stacked.png'
        };
        break;
      default:
        customerInfo = {
          phoneNumber: '(888) 249-3068',
          brandLogo: 'https://s3.us-east-1.amazonaws.com/impreso.sheet.asset/RFID_Hotel_RLogo_black.png'
        };
    }

    this.phoneNumber = customerInfo.phoneNumber;

    this.initSubscriptions = [
      this.process
        .subscribe(process => {
          this.layout = process;
          this.brandLogo = customerInfo.brandLogo;
          this.logoWidth = '320';
        }),

      this.shipmentDetailsView
        .subscribe((shipmentDetailsViewState: any) => {
          console.log(shipmentDetailsViewState)
          const {
            // addressValidationMsg,
            packingSlipPrinting,
          } = shipmentDetailsViewState;
          this.packingSlipPrinting      = packingSlipPrinting;
        })
      ]
      
      this.jobs.forEach((job) => {
        let TotalQty = 0;
        console.log(job.splitJobs)
        if(job.isSplit && job.splitJobs.length){
          job.splitJobs.forEach((split) => {
            TotalQty += Number(split.label_qty);
          })
          this.splitTotalQty[job.id] = TotalQty;
        } 

        if (job.itemInfo) {
          this.info[job.id] = [];
          
          const itemDetailsName = {
            product_group : 'Product Group',
            mt_item : 'MT Item',
            drawing_number : 'Drawing Number',
            description : 'Description',
            retail_price : 'Retail Price',
            dor : 'DOR',
          } 
          
          Object.keys(job.itemInfo).map((key) => {
            if(job.itemInfo[key] && key != 'preferred_roll_diameter'){
              this.info[job.id].push(`${itemDetailsName[key]}: ${job.itemInfo[key]}`)
            }
          })
        }

      });

      this.jobs.forEach((job: any) => {
        job.isShuffled = (job.rfid_is_shuffled === true) || (job.rfid_is_shuffled === 'true') || (job.rfid_is_shuffled === 1);
        if (!job.isShuffled) {
          return;
        }
        const frontFallback: string | undefined = job && job.rfid_artworks && job.rfid_artworks.front ? job.rfid_artworks.front.preview_url : undefined;
        const backFallback : string | undefined = job && job.rfid_artworks && job.rfid_artworks.back  ? job.rfid_artworks.back.preview_url  : undefined;
        const frontArtworks : string[] = this.getArtworks(job, 'front', frontFallback);
        const backArtworks : string[] = this.getArtworks(job, 'back',  backFallback);
        job.shuffleFrontEntries = this.buildShuffleEntries(frontArtworks);
        job.shuffleBackEntries  = this.buildShuffleEntries(backArtworks);
      });
  }

  ngOnDestroy(): void {
    this.initSubscriptions.forEach(subscription => subscription.unsubscribe());
    console.log("Destroying...");
  }

  trackByUrl = (_: number, entry: { url: string }) => entry.url;

  private getArtworks(job: any, side: 'front' | 'back', fallback?: string): string[] {
    try {
      const designs = Array.isArray(job.rfid_shuffle_designs) ? job.rfid_shuffle_designs : [];
      const urls: string[] = [];
      for (const design of designs) {
        if (!design) continue;
        if (design[side]) {
          const val = design[side];
          if (val && val.preview_url) {
            urls.push(val.preview_url);
          }
        }
      }
      const limited = urls.slice(0, 7);
      return limited.length ? limited : (fallback ? [fallback] : []);
    } catch (e) {
      return fallback ? [fallback] : [];
    }
  }

  private buildShuffleEntries(urls: string[]): Array<{ url: string, style: string, styleObj: { [key: string]: any } }> {
    const count = Math.min(urls.length, 7);
    const positions = this.shuffleArtworkTemplate[count];
    const heightPercent = this.heightByCount[count];
    const widthPercent  = this.widthByCount[count];
    return urls.slice(0, count).map((url, index) => {
      const pos = positions[index];
      const z = index + 1;
      const style = `position:absolute; left:${pos.left}px; top:${pos.top}px; z-index:${z}; height:${heightPercent}; width:${widthPercent}; border-radius:9px; border:1px solid #ddd; box-shadow:0 2px 4px rgba(0,0,0,0.15); background:#fff;`;
      const styleObj = {
        position: 'absolute',
        left: `${pos.left}px`,
        top: `${pos.top}px`,
        zIndex: z,
        height: heightPercent,
        width: widthPercent,
        borderRadius: '9px',
        border: '1px solid #ddd',
        boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
        background: '#fff',
      };
      return { url, style, styleObj };
    });
  }

  printPackingSlip(qty: number): void {
    if (!this.packingSlipPrinting) {
      this.printerService.printPackingSlip(
        this.jobs,
        this.order,
        this.shipment,
        qty,
        true, // isRfid
        'Tray 2'
      );
    }
  }
}



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/modals/rfid-packing-slip-modal/rfid-packing-slip-modal.component.ts